<div class="products-list-container">
  <!-- Products header bar -->
  <div class="products-header-bar">
    <div class="products-header-info">
      <div class="products-stat">{{'quotations_and_orders.explore_catalog' | translate}}: </div>
      <div class="products-title">{{pricelist_name || '--'}}</div>
    </div>
    <div class="products-stats">
      <div class="products-stat">{{getSelectedProductsCount()}} {{ 'quotations_and_orders.product_selected' | translate
        }}</div>
    </div>
  </div>
  <!-- Catalog level deals -->
  <app-gift-banner *ngIf="featureFlags.loyaltyEnabled && catalog && getGifts().length > 0" [gifts]="getGifts()"></app-gift-banner>
  <!-- Filter bar -->
  <div class="filter-container">
    <div class="search-filter-group">
      <div class="search-box">
        <input type="text" [formControl]="nameControleProduct" placeholder="{{ 'quotations_and_orders.search_by_product_name' | translate }}">
        <div class="search-icon">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z"
              stroke="#8E97A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M15.75 15.75L12.4875 12.4875" stroke="#8E97A3" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="filter-button-group">
        <button class="filter-button" (click)="setFilter()" [ngClass]="{'activeFilter': isProductsFiltered}">
          <div class="action-button-icon filter-icon">
            <img src="assets/icones/filter_icon.svg" alt="">
          </div>
          <span class="action-button-text">{{ 'common.filter' | translate }}</span>
          <div class="clear-icon-container" *ngIf="isProductsFiltered">
            <img class="clear-icon" (click)="clearFilter(); $event.stopPropagation()" src="assets/icones/clear-icon.svg"
              alt="">
            <div class="clear-tooltip">
              {{ "common.clear_filters" | translate }}
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
  <!-- No products message -->
  <div class="no-products-message" *ngIf="products.length === 0">
    <div class="message-content">
      <p>{{ 'quotations_and_orders.all_products_in_catalog' | translate }}</p>
    </div>
  </div>
  <!-- Products table -->
  <div class="products-table-container">
    <table class="products-table" [class.margin-on-cost-mode]="isMarginOnCost" [formGroup]="quantityForm">
      <thead>
        <tr>
          <th class="table-header header-checkbox">
            <label class="checkbox">
              <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()">
              <span class="checkmark"></span>
            </label>
          </th>
          <th class="table-header">
            <span class="header-label">Img</span>
          </th>
          <th class="table-header">
            <div class="header-title-with-sort" (click)="sort('name')">
              <span class="header-label">{{ 'quotations_and_orders.product' | translate }}</span>
              <div class="sort-arrows">
                <span class="arrow-up"
                  [class.active]="currentSortField === 'name' && currentSortDirection === 'asc'"></span>
                <span class="arrow-down"
                  [class.active]="currentSortField === 'name' && currentSortDirection === 'desc'"></span>
              </div>
            </div>
            <span class="subheader-label">SKU</span>
          </th>
          <th class="table-header">
            <span class="header-label">{{ 'quotations_and_orders.brand' | translate }}</span>
          </th>
          <th class="table-header">
            <div class="header-title-with-sort" (click)="sort('price_unit')">
              <span class="header-label">{{ 'quotations_and_orders.retail_price' | translate }}</span>
              <div class="sort-arrows">
                <span class="arrow-up"
                  [class.active]="currentSortField === 'price_unit' && currentSortDirection === 'asc'"></span>
                <span class="arrow-down"
                  [class.active]="currentSortField === 'price_unit' && currentSortDirection === 'desc'"></span>
              </div>
            </div>
          </th>
          <th class="table-header" *ngIf="isMarginOnCost">
            <div class="header-title-with-sort" (click)="sort('cost')">
              <span class="header-label">{{ 'Catalogs.new_catalog.products.listing.cost' | translate }}</span>
              <div class="sort-arrows">
                <span class="arrow-up"
                  [class.active]="currentSortField === 'cost' && currentSortDirection === 'asc'"></span>
                <span class="arrow-down"
                  [class.active]="currentSortField === 'cost' && currentSortDirection === 'desc'"></span>
              </div>
            </div>
          </th>
          <th class="table-header">
            <div class="header-title-with-sort" (click)="sort('final_price')">
              <span class="header-label">{{ 'quotations_and_orders.unit_price' | translate }}</span>
              <div class="sort-arrows">
                <span class="arrow-up"
                  [class.active]="currentSortField === 'final_price' && currentSortDirection === 'asc'"></span>
                <span class="arrow-down"
                  [class.active]="currentSortField === 'final_price' && currentSortDirection === 'desc'"></span>
              </div>
            </div>
          </th>
          <th class="table-header">
            <div class="header-title-with-sort stock-header" (click)="sort('stock')">
              <span class="header-label">{{ 'inventory.stock' | translate }}</span>
              <div class="sort-arrows">
                <span class="arrow-up"
                  [class.active]="currentSortField === 'stock' && currentSortDirection === 'asc'"></span>
                <span class="arrow-down"
                  [class.active]="currentSortField === 'stock' && currentSortDirection === 'desc'"></span>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let product of currentFilter">
          <!-- Product rows -->
          <tr class="product-row" [class.disabled]="product.disabled">
            <td class="product-cell">
              <label class="checkbox">
                <input type="checkbox" [checked]="product.selected" (change)="toggleSelectProduct(product)">
                <span class="checkmark"></span>
              </label>
            </td>
            <td class="product-cell">
              <div class="product-image">
                <img [src]="product.image ? baseUrl + product.image + '?thumbnail=1' : placeholder" alt="">
              </div>
            </td>
            <td class="product-cell">
              <div class="product-details">
                  <div class="product-name">{{product.name}}</div>
                  <div class="product-sku">{{product | productCode}}</div>
              </div>
            </td>
            <td class="product-cell brand-cell">
              <div class="product-brand">
                {{ product.brand?.name || '—-' }}
              </div>
            </td>
            <td class="product-cell price-cell">
              <div class="price-info">
                  {{ getRetailPrice(product) }}
                  <app-gift-tooltip *ngIf="featureFlags.loyaltyEnabled && getProductGifts(product).length > 0" [gifts]="getProductGifts(product)"></app-gift-tooltip>
              </div>
            </td>
            <td class="product-cell price-cell" *ngIf="isMarginOnCost">
              {{ getProductCost(product) }}
            </td>
            <td class="product-cell">
              <div class="unit-price">
                <span class="unit-price-value">
                  {{ getProductFinalPrice(product) }}
                </span>
              </div>
            </td>
            <td class="product-cell stock-cell">
              <ng-container
                *ngIf="!product?.is_owned || product.stock == null; else owned">
                <span class="tag">
                  {{ 'inventory.notOwned' | translate }}
                </span>
              </ng-container>

              <ng-template #owned>
                <div>
                  {{ product.stock?.quantity }}
                </div>
              </ng-template>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
